<h1 mat-dialog-title>{{ data.title }}</h1>
    <div mat-dialog-content>
      <p>{{ data.message }}</p>
    </div>
    <div mat-dialog-actions align="end">
      <button mat-stroked-button
          type="button"
          (click)="onNoClick()">No</button>
      <button mat-stroked-button
          type="button"
          [mat-dialog-close]="true">Yes</button>
    </div>
